module.exports = __webpack_public_path__ + "img/sleeve upper flounce length.714658fc.png";